import React, { useState } from 'react';
import { Link } from 'gatsby';
import locales from '../../config/i18n';
import { LocaleContext } from './layout';

import { css } from '@emotion/react';
import { colors } from '../styles/styles';
import { getLanguageTargets } from '../utils/language-targets';

export default function LangSwitcher({ flags }) {
  let { locale, location, alternateLanguages, availablePaths } =
    React.useContext(LocaleContext);
  locale = locale ? locale : 'en-gb'; // fix: 404 doesnt know the locale
  const [isOpenLangSelect, setIsOpenLangSelect] = useState(false);
  const targets = getLanguageTargets({
    locale,
    pathname: location.pathname,
    alternateLanguages,
    availablePaths,
  });
  if (!targets.length) return null;
  return (
    <div
      className="dropdown dropdown__lang is-active"
      css={langSwitcherCss}
      onMouseEnter={() => setIsOpenLangSelect(true)}
      onMouseLeave={() => setIsOpenLangSelect(false)}
    >
      <div className="dropdown-trigger">
        <button type="button" className="activeLang button is-rounded">
          {flags.nodes
            .filter((node) => node.name === `flag-${locale}`)
            .map((loc) => (
              <img
                loading="lazy"
                decoding="async"
                key={locale}
                src={loc.publicURL}
                alt={locales[locale].langName}
                className="flag"
              />
            ))}
          <span>{locales[locale].langName}</span>
          <i className="icon is-small icon-chevron_down" />
        </button>
      </div>
      <div
        className={`allLang dropdown-menu ${
          !isOpenLangSelect ? 'is-hidden' : ''
        }`}
        id="dropdown-menu"
        role="menu"
      >
        <div className="dropdown-content">
          {targets.map(({ lang, to }) => {
            return (
              <div key={locales[lang].path} className={locales[lang].path}>
                <Link
                  key={lang}
                  to={to}
                  className="dropdown-item"
                  onClick={() => setIsOpenLangSelect(false)}
                >
                  {flags.nodes
                    .filter((node) => node.name === `flag-${lang}`)
                    .map((loc) => (
                      <img
                        loading="lazy"
                        decoding="async"
                        key={lang}
                        src={loc.publicURL}
                        alt={locales[locale].langName}
                        className="flag"
                      />
                    ))}
                  {locales[lang].langName}
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

const langSwitcherCss = css`
  .button {
    border: 0;
    background-color: ${colors.blueLang};
    padding-left: 10px;
    padding-right: 40px;
  }

  .icon {
    padding-left: 5em;
  }

  .flag {
    width: 27px;
    margin-right: 10px;
  }
  @media screen and (min-width: 1024px) and (max-width: 1453px) {
    .flag {
      width: 24px;
      margin-right: 1px;
    }
  }

  .dropdown-item {
    display: flex;
    align-items: center;
  }
`;
